import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {SurveyService} from '../../../services/surveys.service';
import {TranslateService} from '@ngx-translate/core';
import {ScriptLoaderService} from 'angular-google-charts';
import {AlertService} from '../../../services/general/alert.service';
import {ToastService} from '../../../services/general/toast.service';
import {PageEvent} from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import {EChartsOption} from 'echarts';

@Component({
  selector: 'app-survey-all-responses',
  templateUrl: './survey-all-responses.component.html',
  styleUrls: ['./survey-all-responses.component.scss']
})
export class SurveyAllResponsesComponent implements OnInit {

  constructor(
    public surveyService: SurveyService,
    public translateService: TranslateService,
    private loaderService: ScriptLoaderService,
    private toast: ToastService
  ) {

  }

  @Input() survey: any;
  @Input() surveyId: any;

  tabIndex = 0;
  loading = false;
  showPrivateInfo = false;
  questions = [];
  totalQuestions = 0;

  currentPageIndex: number = 0;
  pageSize: number = 1;

  chartOptions!: EChartsOption;
  answeredCount = 0;
  draftCount = 0;
  notAnsweredCount = 0;

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.loadQuestions(this.currentPageIndex + 1, this.pageSize); // Backend pages are 1-based
    this.renderChart();
  }

  loadQuestions(page: number, perPage: number) {
    this.loading = true;
    this.surveyService.surveyResponses(
      this.surveyId,
      page,
      perPage,
      (result) => {
        this.questions = result.data;
        this.totalQuestions = result.total;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  onPageChange(event: PageEvent) {
    this.currentPageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadQuestions(this.currentPageIndex + 1, this.pageSize);
  }

  onChangeStatus(event) {
    this.loading = true;
    const model = {
      status: this.survey?.status
    };
    this.surveyService.changeSurveyStatus(this.survey?.id, model, (result) => {
      if (this.survey?.status === 'EVALUATING') {
        this.toast.success(
          this.translateService.instant('generic.success'),
          this.translateService.instant('modals.modal-survey-details.resposes-enabled')
        );
      }
      if (this.survey?.status === 'CLOSED') {
        this.toast.success(
          this.translateService.instant('generic.success'),
          this.translateService.instant('modals.modal-survey-details.resposes-blocked')
        );
      }
      this.loading = false;
    }, (err) => {
      this.survey.status = err.error?.status;
      this.loading = false;
    });
  }

  toggleAnonymousData() {
    this.showPrivateInfo = !this.showPrivateInfo;
  }

  private renderChart(): void {
    const members = this.survey?.members || [];

    this.answeredCount = members.filter(m => m.response_status === 'SENT').length;
    this.draftCount = members.filter(m => m.response_status === 'DRAFT').length;
    this.notAnsweredCount = members.length - this.answeredCount - this.draftCount;

    this.chartOptions = {
      tooltip: {trigger: 'item'},
      legend: {
        orient: 'vertical',
        left: 'left',
        textStyle: { color: '#666' }
      },
      series: [
        {
          name: this.translateService.instant('components.responses.responses'),
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: { show: false, position: 'center' },

          data: [
            {
              value: this.answeredCount,
              name: this.translateService.instant('generic.who-has-responded'),
              itemStyle: {color: '#27ae60'}
            },
            {
              value: this.notAnsweredCount,
              name: this.translateService.instant('generic.who-has-not-responded'),
              itemStyle: {color: '#e57373'}
            },
            {
              value: this.draftCount,
              name: this.translateService.instant('generic.answers.draft'),
              itemStyle: {color: '#ffb74d'}
            },
          ]
        }
      ]
    };
  }

  get answersSent() {
    return this.survey?.members?.filter((m) => m.response_status === 'SENT') || [];
  }
}
